import fitsyncImg from '../images/aaharai2.png';
import nextera1 from '../images/nextera1.png';
import nextera2 from '../images/nextera2.png';
import tcs1 from '../images/TCS1.png';
import tcs2 from '../images/TCS2.png';

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'Content', href: '/content' },
  { label: 'Contact', href: '#contact' }
];

export const services = [
  {
    id: 'full-stack-development',
    title: 'Full Stack Development',
    customerView: 'You get one partner for frontend, backend, and deployment.',
    description:
      'I build complete websites and web apps from planning to launch, so you do not need separate teams for design handoff, API work, and final deployment.',
    deliverables: ['Business-ready UI + backend', 'Secure APIs and database design', 'Performance and SEO baseline setup'],
    tags: ['Best for Startups', 'Scalable Architecture', 'Launch Ready'],
    tools: [
      {
        name: 'React',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
        use: 'Builds fast, interactive frontend screens.'
      },
      {
        name: 'Node.js',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
        use: 'Runs secure server-side business logic.'
      },
      {
        name: 'Express',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg',
        use: 'Creates API routes for app features.'
      },
      {
        name: 'MongoDB',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
        use: 'Stores your product data reliably.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1593720213428-28a5b9e94613?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'website-design',
    title: 'Website Design',
    customerView: 'Clear, premium visuals that make your brand look high-value.',
    description:
      'I design conversion-focused websites with strong hierarchy, intentional spacing, and a premium visual language that helps users trust your business fast.',
    deliverables: ['Wireframe to polished UI direction', 'Responsive layout system', 'Conversion-focused section planning'],
    tags: ['Premium Aesthetic', 'Brand Clarity', 'Conversion Focus'],
    tools: [
      {
        name: 'Figma',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg',
        use: 'Used to design clean layouts and UI systems.'
      },
      {
        name: 'Tailwind',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg',
        use: 'Helps craft consistent visual styling quickly.'
      },
      {
        name: 'Framer Motion',
        logo: 'https://cdn.simpleicons.org/framer/000000',
        use: 'Adds subtle, premium motion to interactions.'
      },
      {
        name: 'Bootstrap',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg',
        use: 'Speeds up responsive structure when needed.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1587440871875-191322ee64b0?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'website-maintenance',
    title: 'Website Maintenance',
    customerView: 'Your site stays fast, secure, and updated after launch.',
    description:
      'I handle post-launch website updates and future maintenance so your site keeps running smoothly. That includes new content updates, bug fixes, performance tuning, and ongoing reliability support.',
    deliverables: ['Website updates and future maintenance support', 'Bug fixes and performance improvements', 'Content and CMS update handling'],
    tags: ['Ongoing Support', 'Reliability First', 'Performance Care'],
    tools: [
      {
        name: 'GitHub',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg',
        use: 'Tracks updates and keeps releases controlled.'
      },
      {
        name: 'React',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
        use: 'Maintains and improves frontend features.'
      },
      {
        name: 'Tailwind',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg',
        use: 'Keeps UI styling consistent during updates.'
      },
      {
        name: 'Vercel',
        logo: 'https://cdn.simpleicons.org/vercel/000000',
        use: 'Deploys fast updates with minimal downtime.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'ai-integration',
    title: 'AI Integration',
    customerView: 'I integrate AI APIs into your website for practical features like chatbots and smart workflows.',
    description:
      'AI integration means connecting reliable AI APIs directly to your website to add features such as customer chatbots, assistant flows, content help, and other smart automations based on your business needs.',
    deliverables: ['AI API integration into your website', 'Chatbot and assistant experience setup', 'Custom smart workflow and automation features'],
    tags: ['Automation', 'Smarter UX', 'Business Efficiency'],
    tools: [
      {
        name: 'OpenAI',
        logo: 'https://cdn.simpleicons.org/openai/000000',
        use: 'Powers chatbot and assistant intelligence.'
      },
      {
        name: 'Python',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
        use: 'Handles AI processing and data workflows.'
      },
      {
        name: 'Node.js',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
        use: 'Connects AI APIs with your web platform.'
      },
      {
        name: 'PostgreSQL',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
        use: 'Stores and serves AI-related data securely.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1677691820099-a6e8040aa077?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'landing-page-design',
    title: 'Landing Page Design',
    customerView: 'High-converting landing pages built to turn traffic into customers.',
    description:
      'Focused, one-page experiences crafted for ads, launches, and campaigns. Strong headline structure, clear CTAs, and motion polish so visitors actually scroll, read, and convert.',
    deliverables: ['Conversion-focused copy structure', 'Custom hero + section design', 'A/B variant + analytics ready'],
    tags: ['High Converting', 'Launch Day Ready', 'Ad Friendly'],
    tools: [
      {
        name: 'React',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
        use: 'Renders blazing-fast landing experiences.'
      },
      {
        name: 'Tailwind',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg',
        use: 'Styles premium, responsive sections quickly.'
      },
      {
        name: 'Framer Motion',
        logo: 'https://cdn.simpleicons.org/framer/000000',
        use: 'Adds subtle motion that lifts conversion.'
      },
      {
        name: 'Vercel',
        logo: 'https://cdn.simpleicons.org/vercel/000000',
        use: 'Ships pages globally with edge speed.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'ecommerce-development',
    title: 'E-Commerce Development',
    customerView: 'Online stores that load fast, look premium, and actually sell.',
    description:
      'I build modern e-commerce experiences with clean product pages, smooth checkout, and reliable backend integrations so you can focus on growth instead of fighting your storefront.',
    deliverables: ['Custom storefront + product pages', 'Cart, checkout, and payment setup', 'Inventory and order workflow'],
    tags: ['Conversion First', 'Stripe + Razorpay', 'Mobile Ready'],
    tools: [
      {
        name: 'Next.js',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg',
        use: 'Powers fast, SEO-friendly storefronts.'
      },
      {
        name: 'Stripe',
        logo: 'https://cdn.simpleicons.org/stripe/635BFF',
        use: 'Handles secure global payments.'
      },
      {
        name: 'MongoDB',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
        use: 'Stores products, orders, and customers.'
      },
      {
        name: 'Tailwind',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg',
        use: 'Crafts a clean, premium shopping UI.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1556742111-a301076d9d18?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'seo-performance',
    title: 'SEO & Performance Optimization',
    customerView: 'Faster site, better Google rankings, more organic traffic.',
    description:
      'Technical SEO, Core Web Vitals tuning, and page-speed engineering so your site loads fast, ranks higher, and stops losing visitors to slow load times.',
    deliverables: ['Core Web Vitals + Lighthouse tuning', 'On-page SEO and schema setup', 'Image, font, and bundle optimization'],
    tags: ['Faster Loads', 'Higher Rankings', 'Better Conversions'],
    tools: [
      {
        name: 'Lighthouse',
        logo: 'https://cdn.simpleicons.org/googlechrome/4285F4',
        use: 'Audits and tracks performance scores.'
      },
      {
        name: 'Google Analytics',
        logo: 'https://cdn.simpleicons.org/googleanalytics/E37400',
        use: 'Measures real-world user behavior.'
      },
      {
        name: 'Schema.org',
        logo: 'https://cdn.simpleicons.org/schemadotorg/E50000',
        use: 'Adds rich snippets for search results.'
      },
      {
        name: 'Vercel',
        logo: 'https://cdn.simpleicons.org/vercel/000000',
        use: 'Edge hosting for global speed.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?auto=format&fit=crop&w=1400&q=80'
  },
  {
    id: 'dashboard-development',
    title: 'Dashboard & Admin Panels',
    customerView: 'Internal tools that actually feel good to use every day.',
    description:
      'I build admin panels, internal dashboards, and operator UIs with clean data visualization, role-based access, and workflows that your team will not curse at.',
    deliverables: ['Role-based access and auth', 'Charts, tables, and real-time data', 'Audit trails and clean operator UX'],
    tags: ['Operator Friendly', 'Real-Time Data', 'Secure by Design'],
    tools: [
      {
        name: 'React',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
        use: 'Builds responsive admin interfaces.'
      },
      {
        name: 'TypeScript',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
        use: 'Keeps dashboard logic type-safe.'
      },
      {
        name: 'PostgreSQL',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
        use: 'Stores structured operational data.'
      },
      {
        name: 'Node.js',
        logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
        use: 'Serves dashboard APIs reliably.'
      }
    ],
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1400&q=80'
  }
];

export const projects = [
  {
    id: 'nextera',
    title: 'NextEra',
    client: 'Freelance Client',
    category: 'Full Stack / Enterprise Web / 2026',
    summary:
      'Designed and shipped a modern marketing + product site for NextEra with conversion-focused layouts and a fast, scalable React frontend.',
    resultTag: 'Launch in under 4 weeks',
    images: [nextera1, nextera2],
    href: '#contact',
    tech: ['React', 'Tailwind', 'Node.js']
  },
  {
    id: 'the-career-space',
    title: 'The Career Space',
    client: 'The Career Space',
    category: 'Full Stack / EdTech & Careers / 2026',
    summary:
      'Designed and built a modern career-focused platform with clean information architecture, fast operator UX, and a polished frontend that helps users navigate opportunities with confidence.',
    resultTag: 'Improved engagement by 38%',
    images: [tcs1, tcs2],
    href: '#contact',
    tech: ['React', 'Express', 'PostgreSQL']
  },
  {
    id: 'fitsync',
    title: 'FitSync',
    client: 'Independent Product',
    category: 'Full Stack / Fitness / 2026',
    summary: 'Built a user-friendly tracking platform with streamlined onboarding and analytics for active users.',
    resultTag: '34% better user retention',
    images: [fitsyncImg],
    href: '#contact',
    tech: ['React', 'Node.js', 'MongoDB']
  }
];

export const socials = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/nithinjampala/' },
  { label: 'GitHub', href: 'https://github.com/nithinsaichoudary' },
  { label: 'Instagram', href: 'https://www.instagram.com/nithincj03?igsh=MXZ3eGZ2bjFjZWMzdg%3D%3D&utm_source=qr' }
];

export const processSteps = [
  {
    id: 'discover',
    title: 'Discovery',
    detail: 'We define goals, audience, and conversion priorities to set a clean direction.'
  },
  {
    id: 'structure',
    title: 'Structure',
    detail: 'Information architecture and wireflow planning keep every section purposeful.'
  },
  {
    id: 'design',
    title: 'Design',
    detail: 'Editorial UI direction, typography hierarchy, and premium visual polish.'
  },
  {
    id: 'build',
    title: 'Build',
    detail: 'Scalable React implementation with performance-first frontend engineering.'
  },
  {
    id: 'launch',
    title: 'Launch + Support',
    detail: 'QA, deployment readiness, and smooth iteration support after go-live.'
  }
];

export const testimonials = [
  {
    id: 't1',
    quote:
      'Nithin delivered a polished site faster than expected. Clear communication, premium design sense, and zero hand-holding required.',
    name: 'Project Lead',
    role: 'NextEra'
  },
  {
    id: 't2',
    quote:
      'Strong full stack execution. Took an unclear brief and turned it into a clean, working internal tool our team actually enjoys using.',
    name: 'Engineering Lead',
    role: 'The Career Space'
  },
  {
    id: 't3',
    quote:
      'Great balance of design and engineering. Shipped on time, code is clean, and the UI feels premium without being heavy.',
    name: 'Founder',
    role: 'FitSync'
  }
];

export const faqs = [
  {
    q: 'Do you take freelance website projects in Hyderabad and remotely?',
    a: 'Yes. I work with clients in Hyderabad, across India, and globally as a freelance full stack web developer and website designer.'
  },
  {
    q: 'What kind of websites do you build?',
    a: 'Premium marketing sites, web apps, dashboards, AI-integrated tools, and full stack React + Node.js products. Custom built, no templates.'
  },
  {
    q: 'How long does a typical project take?',
    a: 'A focused marketing site ships in 2 to 4 Days. Full product builds usually run 4 to 10 Days depending on scope.'
  },
  {
    q: 'Do you also handle maintenance after launch?',
    a: 'Yes. I offer ongoing website maintenance, bug fixes, performance tuning, and content updates as a service.'
  }
];
